import React from 'react'
import classNames from 'classnames'

import './FormFieldGrid.scss'

/**
 * @import import { FormFieldGrid } from '@/components/forms/FormFieldGrid'
 * @param {object} props
 * @param {string} [props.className] Additional classes on the grid element
 * @param {node} props.children FormFields laid out on the 12-column grid via their `span` prop
 */
export const FormFieldGrid = ({ className, children, ...props }) => (
  <div className={classNames('form-field-grid', className)} {...props}>
    {children}
  </div>
)
